import RefreshButton from "./RefreshButton";
import CallsFilter from "./CallsFilter";

export const PaginationAndFilter = ({
                                        clearDates,
                                        fromDate,
                                        toDate,
                                        setFromDate,
                                        setToDate,
                                        displayRefresh = false,
                                        hasNext,
                                        hasPrevious,
                                        goPrevious,
                                        goNext,
                                        isLoading,
                                        refreshFn,
                                        isError,
                                        lat,
                                        lng,
                                        setLat,
                                        setLng
                                    }) => {
    return <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-3">
            <button
                onClick={goPrevious}
                aria-label="Previous page"
                className={"relative inline-flex h-12 w-12 items-center justify-center rounded-xl border border-gray-300 bg-blue-200 " + (hasPrevious ? " text-blue-700 hover:bg-gray-50" : " text-gray-400")}
                disabled={!hasPrevious}
            >
                {PreviousIcon}
            </button>
            {displayRefresh && <div className="shrink-0">
                <RefreshButton displaySpinner={isLoading}
                               refreshFn={refreshFn}
                               getErrorMessage={() => isError ? "There was some problem while loading call data, please try refreshing the browser" : ""}/>
            </div>}
            {!displayRefresh && <div className="h-12 w-12"/>}
            <button
                onClick={goNext}
                aria-label="Next page"
                className={"relative inline-flex h-12 w-12 items-center justify-center rounded-xl border border-gray-300 bg-blue-200 " + (hasNext ? " text-blue-700 hover:bg-gray-50" : " text-gray-400")}
                disabled={!hasNext}
            >
                {NextIcon}
            </button>
        </div>
        {displayRefresh && <CallsFilter
            clearDates={clearDates}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            lat={lat}
            lng={lng}
            setLat={setLat}
        />}
    </div>;
}

const PreviousIcon = <svg className="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m15 18 -6 -6 6 -6"/>
</svg>;

const NextIcon = <svg className="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m9 18 6 -6 -6 -6"/>
</svg>;
